import {ReactNode} from 'react';
import {requestContext} from '../../../../../../common/requestContext';
import {Loading} from '../../../../../../design-system/atoms/Loading/Loading';
import {PagewebError} from '../../../../../../errors/PagewebError.class';
import {useFetchTalkViewer} from '../hook/useFetchTalkViewer.hook';

interface TalkViewerFetcherProps {
  productId: number;
  seriesId: number;
  children: ReactNode;
}

export function TalkViewerFetcherHeadless({
  productId,
  children,
  seriesId,
}: TalkViewerFetcherProps) {
  const {isLoading, error, data} = useFetchTalkViewer({
    productId,
    seriesId,
  });
  if (error) {
    throw new PagewebError(error);
  }
  if (isLoading) {
    if (requestContext.requestInfo.display.isWebView) {
      return null;
    }
    return (
      <div className="flex-center-full">
        <Loading />
      </div>
    );
  }

  return <>{!!data && children}</>;
}
